import React from 'react';
import './ToolTip.css';

function ToolTip({ hintText }) {
    return (
        <span className="tooltip-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#750F35"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4" />
                <path d="M12 8h.01" />
            </svg>
            <span className="tooltip-text">
                <div className="tooltip-header"></div>
                <p>
                    {hintText}
                </p>
            </span>
        </span>
    )
}

export default ToolTip;